import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=9ca6fbd6&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=ts&"
export * from "./RoleCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=9ca6fbd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6fbd6",
  null
  
)

export default component.exports